export default "__VITE_ASSET__CMyDJ1ZW__"